module.exports = "https://static.energy5.com/_next/static/images/slide5-822397c56f6e217a81452ec7506d0762.png";